import { mergeContentEnginePrintChunks, CONTENT_ENGINE_DEFAULT_PRINT_PAGE_PADDING } from '@pm2/ui-layout';
import { printManager, DESIGN_SIZES, makePM2PrintFooterSlot, PM2PrintHeaderSlot, printerSelectors } from '@provider/print';
import { printAST, findAllInAST } from '@utils/ast';
import { HOURS_TO_MS } from '@utils/constants';
import { ContentPrintPage } from './page.content.js';
import { section } from './page.content.style.js';
import { GlossaryWordsPrintPage } from './page.glossary-words.js';
import { jsx } from 'react/jsx-runtime';

async function generateTextComponentPrintConfig(node, printers, context) {
  const preset = getPresetByTemplate({
    isRichText: node.meta.isRichText,
    template: node.pm2.pdfExport?.template
  });

  // In case the provided node contains richtext content then simply print all
  // chunks using our default ContentEngine printers
  if (node.meta.isRichText) {
    await printManager.preparePrint(node.id || String(Math.random()), context, {
      debug: false,
      format: "A4-portrait",
      sections: mergeContentEnginePrintChunks(printAST(node, printers))
    });
  } else {
    // ... else we should print content based on the provided configuration
    // (i.e. by adding columns and line counting as desired.)
    const lineCountInterval = node.pm2.pdfExport?.lineCount ? 5 : 0;
    const columnCount = getColumnCountByTemplate(node.pm2.pdfExport?.template);
    const glossaryWordsColumnCount = getFooterColumnCountByTemplate(node.pm2.pdfExport?.template);
    const format = preset === "full-paper.landscape" ? "A4-landscape" : "A4-portrait";
    const glossaryWords = findAllInAST(node.children, it => it.nodeType === "text-component.glossary-word");
    await printManager.preparePrint(node.id || String(Math.random()), context, {
      debug: false,
      format,
      sections: [{
        className: section,
        pages: [{
          type: "split",
          lineCount: lineCountInterval ? {
            showPerNthLine: lineCountInterval
          } : undefined,
          padding: CONTENT_ENGINE_DEFAULT_PRINT_PAGE_PADDING,
          content: /*#__PURE__*/jsx(ContentPrintPage, {
            node: node,
            columnCount: columnCount,
            lineCountInterval: lineCountInterval
          })
        }, glossaryWords.length ? {
          type: "split",
          padding: CONTENT_ENGINE_DEFAULT_PRINT_PAGE_PADDING,
          content: /*#__PURE__*/jsx(GlossaryWordsPrintPage, {
            glossaryWords: glossaryWords,
            columnCount: glossaryWordsColumnCount
          })
        } : undefined],
        config: {
          slots: {
            header: PM2PrintHeaderSlot,
            footer: makePM2PrintFooterSlot("pdf")
          },
          designSizeInPx: DESIGN_SIZES.ONE_TO_ONE(format)
        }
      }]
    });
  }
  return {
    format: "pdf",
    fileName: node.meta.caption.title?.value,
    baseUrl: window.location.href,
    preset,
    cache: 8 * HOURS_TO_MS,
    input: document.querySelector(printerSelectors.container()) ?? document.body
  };
}
function getPresetByTemplate(config) {
  if (config.isRichText) {
    return "full-paper.portrait";
  }
  switch (config.template) {
    case "article":
    case "book":
    case "book-language":
    case "hans-reitzel":
    case "munksgaard":
      return "full-paper.landscape";
    case "source":
      return "full-paper.portrait";
    default:
      return "full-paper.portrait";
  }
}
function getColumnCountByTemplate(template) {
  switch (template) {
    case "article":
    case "hans-reitzel":
    case "munksgaard":
      return 3;
    case "book":
    case "book-language":
      return 2;
    default:
      return 1;
  }
}
function getFooterColumnCountByTemplate(template) {
  switch (template) {
    case undefined:
    case "source":
      return 2;
    default:
      return 3;
  }
}

export { generateTextComponentPrintConfig };
//# sourceMappingURL=_generate-print-config.js.map
